import { StaticImageData } from 'next/image'

import happyCustomer from '@images/happy-customer.png'
import bestOffers from '@images/person-holding-phone-with-pound-symbol.png'
import totallyMoneyLogoOnScreen from '@images/totallymoney-logo-on-phone.png'

type WhyTotallyMoneySection = {
    heading: string
    image: { alt: string; src: StaticImageData }
    text: string
}

export const whyTotallyMoneySections: WhyTotallyMoneySection[] = [
    {
        heading: 'Find the best offers',
        image: {
            alt: 'Person holding phone with money symbol on screen',
            src: bestOffers,
        },
        text: 'We compare credit cards from leading providers to get you the best deals.',
    },

    {
        heading: 'Quick and easy',
        image: {
            alt: 'TotallyMoney logo on a phone screen',
            src: totallyMoneyLogoOnScreen,
        },
        text: 'Find out what credit cards you could be eligible for in under 4 minutes.',
    },

    {
        heading: 'Trusted by thousands',
        image: {
            alt: 'Person holding phone with money symbol on screen',
            src: happyCustomer,
        },
        text: 'Rated excellent on Trustpilot',
    },
]
